import {
    getVariantArray,
    getVariantArrayUnfiltered,
    processEventLogUpload,
    processEventLogHeaderUpload,
    processDetailVariants,
    processDetailEventSummary,
    processStepsTable,
    processVariantsTable,
    processActivitiesTable,
    processTasksTable,
    analyticsTaskHistory,
    analyticsEventHistory,
    analyticsTaskAttributes,
    modelInfo,
    validateDataTransformation,
    retrieveDataTransformation,
    saveEventLogCSV,
    taskCount,
    eventCount,
    processDiscoveryRulesSummaryRow,
    getSaveModel,
    setSaveModel,
    getInsights,
    setInsights,
    getConsultingWorkspace,
    setConsultingWorkspace,
    getDiscoveryRules,
    retrievePlanTier,
    retrieveFiltersArray,
    retrieveVisualizerSettings,
    retrieveDiscoveryRules,
    getModelMetrics,
    filteredTasksCount,
    filteredEventsCount,
    processActivityTypeTable,
    slicedTasksCount,
    slicedEventsCount,
    resetEventLog,
    getInitialLoad,
    metricsExist,
    resetModel,
    eventLogName,
    updateEventLogFlag,
    resetVisualizerSettings,
    getVariantFilterGridState,
    setDiagramVisualizer,
    getCurrentDiagram,
    getEventEmitter,
    processDetailTaskSummary,
    getDetailSource,
    getDecompositionTreeValueFilter,
    getClusterValueFilter,
    getInfluenceAnalysisValueFilter,
    getDecompositionTreeMetricFilter,
    getClusterMetricFilter,
    getActivityTypes,
    getInfluenceAnalysisMetricFilter,
    getMinDiagramWidth,
    getVariantSlicerGridState,
    getVariantSlicerGridFilterState,
    getStepFilterGridState,
    getActivityFilterGridState,
    getActivityTypeFilterGridState,
    getTaskAttributeFilterGridState,    
    getEventAttributeFilterGridState,    
    getRCDescription,
    getHistogramDescription,
    rebuildASA,
    getEntityUpper,
    getModelFileName,
    getEntityLower,
    processEventLog_File,
    processDiscoveryRulesSummary,
    getActiveAction,
    variantsVisualization,
    getHistogramArray,
    tasksVisualization,
    getActivePane,
    getDetailDescription,
    getHistogramTotal,
    getHistogramType,
    getEnvironment,
    getDev,
    getURLHost,
    getUserSessionToken,
    getModelID,
    getLifecycleSeries,
    getLifecycleCategory,
    getDiscoveryRulesGridState,
    retrieveEventLogArray,
    retrieveTaskAttributes,
    retrieveMetricArray,
    getTimeData,
    getTimeColumns,
    getTimeDurationFormat,
    getTimeMetric,
    getActivityArray,
    getAAGridState,
    getInitialAALoad,
    getTimeInActivitySource,
    getTimeAggregation,
    getProcessModelTitle,
    homeStats,
    getTimeActivityType,
    updateDiscoveryRule,
    updateDiscoveryRuleID,
    taskAttributes,
    eventAttributes,
    getIssueTypes,
    getInfluenceAnalysisAttributes,
    getClusterAttributes,
    getInsightTaskCount,
    getActivityType,
    processMinerGauges,
    getDiscoveryRulesEdited,
    getFilters,
    retrieveModelComments,
    retrieveIssueComments,
    retrieveIssueWorklogs,
    costsSummary,
    getCostsGridState,
    retrieveCosts,
    getDataType,
    saveDiscoveryRuleModal,
    getFilterStats,
    retrieveActivityAnalytics,
    retrieveStepAnalytics,
    retrieveIssueAnalytics,
    retrieveEventAnalytics,
    getWorkflowConfiguration,
    getWorkflowTransitions,
    getWorkflowVariants,
    setWorkflowConfiguration,
    getApp
} from '@process-advisor/process-miner/processMiner/processMiner';

export const processMinerMethods = {
    getVariantArray,
    getVariantArrayUnfiltered,
    processEventLogUpload,
    processEventLogHeaderUpload,
    processStepsTable,
    processVariantsTable,
    processActivitiesTable,
    processActivityTypeTable,
    processTasksTable,
    processDetailVariants,
    processDetailEventSummary,
    processDetailTaskSummary,
    analyticsTaskHistory,
    analyticsEventHistory,
    analyticsTaskAttributes,
    modelInfo,
    validateDataTransformation,
    retrieveDataTransformation,
    retrievePlanTier,
    saveEventLogCSV,
    taskCount,
    eventCount,
    retrieveFiltersArray,
    retrieveVisualizerSettings,
    retrieveDiscoveryRules,
    retrieveCosts,
    filteredTasksCount,
    filteredEventsCount,
    slicedTasksCount,
    slicedEventsCount,
    resetEventLog,
    getInitialLoad,
    metricsExist,
    resetModel,
    getActivityTypes,
    eventLogName,
    updateEventLogFlag,
    resetVisualizerSettings,
    setDiagramVisualizer,
    getCurrentDiagram,
    getEventEmitter,
    getDetailSource,
    getDecompositionTreeValueFilter,
    getClusterValueFilter,
    getInfluenceAnalysisValueFilter,
    getDecompositionTreeMetricFilter,
    getClusterMetricFilter,
    getInfluenceAnalysisMetricFilter,
    getMinDiagramWidth,
    getVariantSlicerGridState,
    getVariantSlicerGridFilterState,
    getAAGridState,
    getVariantFilterGridState,
    getStepFilterGridState,
    getActivityFilterGridState,
    getActivityTypeFilterGridState,
    getTaskAttributeFilterGridState,    
    getEventAttributeFilterGridState,    
    getRCDescription,
    getHistogramDescription,
    rebuildASA,
    getEntityUpper,
    getModelFileName,
    getEntityLower,
    processEventLog_File,
    processDiscoveryRulesSummary,
    getActiveAction,
    variantsVisualization,
    tasksVisualization,
    getHistogramArray,
    getSaveModel,
    setSaveModel,
    getActivePane,
    getDetailDescription,
    getHistogramTotal,
    getHistogramType,
    getEnvironment,
    getDev,
    getURLHost,
    getUserSessionToken,
    getModelID,
    getLifecycleSeries,
    getLifecycleCategory,
    getDiscoveryRulesGridState,
    retrieveEventLogArray,
    retrieveTaskAttributes,
    retrieveMetricArray,
    getTimeData,
    getTimeColumns,
    getTimeDurationFormat,
    getTimeMetric,
    getActivityArray,
    getInitialAALoad,
    getTimeInActivitySource,
    getTimeAggregation,
    getProcessModelTitle,
    homeStats,
    getTimeActivityType,
    updateDiscoveryRule,
    updateDiscoveryRuleID,
    taskAttributes,
    eventAttributes,
    getIssueTypes,
    getActivityType,
    getInfluenceAnalysisAttributes,
    getClusterAttributes,
    getInsightTaskCount,
    processMinerGauges,
    getDiscoveryRulesEdited,
    getFilters,
    retrieveModelComments,
    retrieveIssueComments,
    retrieveIssueWorklogs,
    costsSummary,
    getCostsGridState,
    getDataType,
    saveDiscoveryRuleModal,
    getFilterStats,
    getDiscoveryRules,
    processDiscoveryRulesSummaryRow,
    retrieveActivityAnalytics,
    retrieveStepAnalytics,
    retrieveIssueAnalytics,
    retrieveEventAnalytics,
    getWorkflowConfiguration,
    getWorkflowTransitions,
    getWorkflowVariants,
    setWorkflowConfiguration,
    getModelMetrics,
    getApp,
    getInsights,
    setInsights,
    getConsultingWorkspace,
    setConsultingWorkspace,

};
